;(function module() {
  angular.module('app.ui.form.ctrls').controller('TypeAheadController', [
    'SharedApi',
    'EmployersApi',
    '$location',
    function controller(SharedApi, EmployersApi, $location) {
      let vm = this
      // vm.lawFirms = []
      // vm.jobExp = [];
      // // eslint-disable-next-line no-void
      // vm.selected = void 0;
      // vm.universities = []
      // vm.nations = []
      // vm.countries = []
      vm.initializeAboutYouPage = async () => {
        const [
          {data: locationsList},
          {data: nationalitiesList},
          {data: schoolList},
          {data: employersList},
        ] = await Promise.all([
          SharedApi.getAllLocations({
            regions: true,
          }),
          SharedApi.getAllNationalities(),
          SharedApi.getAllSchools(),
          EmployersApi.getAllEmployers({
            isDeleted: false,
            include: ['id', 'name'],
          }),
        ])

        vm.locationsList = locationsList
        vm.nationalitiesList = nationalitiesList
        vm.schoolList = schoolList
        vm.employersList = employersList
      }

      if ($location.url() !== '/user-profile') {
        vm.initializeAboutYouPage()
        // $http
        //   .post('/api/fetchAllFirms', {
        //     contentType: 'application/json',
        //   })
        //   .then(
        //     ({data}) => {
        //       vm.lawFirms = data
        //     },
        //     () => {}
        //   )
        // $http
        //   .post('/api/fetch-nationalities', {
        //     contentType: 'application/json',
        //   })
        //   .then(
        //     ({data}) => {
        //       vm.nations = data
        //     },
        //     () => {}
        //   )
        // $http
        //   .post('/api/fetchUniversities', {
        //     contentType: 'application/json',
        //   })
        //   .then(
        //     ({data}) => {
        //       vm.universities = data
        //     },
        //     () => {}
        //   )
        // return $http
        //   .post('/api/fetch-countries', {
        //     contentType: 'application/json',
        //   })
        //   .then(
        //     ({data}) => {
        //       vm.countries = data
        //     },
        //     () => {}
        //   )
      }
    },
  ])
})()



// WEBPACK FOOTER //
// ./scripts/shared/type-ahead.ctrl.js